import { buildApiUrl } from '../config/environment';

export const fetchTenancyLedger = async (tenancyLedgerId) => {
  try {
    const token = sessionStorage.getItem('access_token');
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await fetch(
      buildApiUrl(`/tenancy-ledgers/${tenancyLedgerId}`),
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Failed to fetch tenancy ledger' }));
      throw new Error(error.message || 'Failed to fetch tenancy ledger');
    }

    const data = await response.json();
    console.log('[TenancyService] Fetched tenancy ledger:', data);
    return data;
  } catch (error) {
    console.error('[TenancyService] Error fetching tenancy ledger:', error);
    throw error;
  }
};
